import { useState } from "react";
import { api, money, errMsg } from "@/lib/api";
import { COLLAB } from "@/constants/testIds";

const field = "w-full px-5 py-3.5 rounded-full border border-[#E7E0D3] bg-white focus:outline-none focus:ring-2 focus:ring-[#E06D44]/40";

const Stat = ({ k, label, value }) => (
  <div data-testid={COLLAB.stat(k)} className="bg-white border border-[#F0EBE1] rounded-[1.5rem] p-5">
    <p className="text-sm text-stone-500">{label}</p>
    <p className="font-heading mt-1 text-3xl font-extrabold">{value}</p>
  </div>
);

export default function CreatorStatsPage() {
  const [handle, setHandle] = useState("");
  const [email, setEmail] = useState("");
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/collab/stats", { handle, email });
      setStats(data);
    } catch (err) {
      setStats(null);
      setError(errMsg(err));
    }
  };

  return (
    <main data-testid={COLLAB.statsPage} className="pt-32 pb-10 max-w-3xl mx-auto px-6 min-h-[60vh]">
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E06D44]">Creator collabs</span>
      <h1 className="font-heading mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight">Your stats</h1>
      <p className="mt-4 text-stone-600">Enter the handle and email you joined with.</p>
      <form onSubmit={submit} className="mt-8 grid sm:grid-cols-[1fr_1fr_auto] gap-3">
        <input data-testid={COLLAB.statsHandle} required value={handle} onChange={(e) => setHandle(e.target.value)} placeholder="@yourhandle" className={field} />
        <input data-testid={COLLAB.statsEmail} required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" className={field} />
        <button data-testid={COLLAB.statsSubmit} className="px-7 py-3.5 rounded-full bg-[#1C1917] text-white hover:bg-[#E06D44] transition-colors">Show stats</button>
      </form>
      {error && <p data-testid={COLLAB.statsError} className="mt-6 text-[#E11D48]">{error}</p>}
      {stats && (
        <section data-testid={COLLAB.statsResult} className="mt-10 fade-up">
          <p className="text-stone-600">@{stats.handle} · code <span className="font-semibold">{stats.code}</span></p>
          <div className="mt-5 grid grid-cols-2 md:grid-cols-4 gap-4">
            <Stat k="clicks" label="Link visits" value={stats.clicks} />
            <Stat k="signups" label="Signups" value={stats.signups} />
            <Stat k="orders" label="Orders" value={stats.orders} />
            <Stat k="sales" label="Sales" value={money(stats.sales)} />
          </div>
          {stats.recent.length > 0 && (
            <ul className="mt-8 divide-y divide-[#F0EBE1] text-sm">
              {stats.recent.map((o) => (
                <li key={o.order_id + o.date} className="py-3 flex justify-between"><span>{new Date(o.date).toLocaleDateString()} · {o.order_id}</span><span>{money(o.total)}</span></li>
              ))}
            </ul>
          )}
        </section>
      )}
    </main>
  );
}
